import React from 'react';
import { Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

/**
 * A field label that renders the title with a small gray (i) icon at the end.
 * The description is hidden and shown as a tooltip when hovering the icon.
 *
 * Usage (drop-in for a Mantine input's `label` prop, instead of `description`):
 *   <TextInput
 *     label={<LabelWithInfo label="電郵" info="電郵可以用作登入名稱及找回密碼" />}
 *     ...
 *   />
 */
export function LabelWithInfo({ label, info }) {
  if (!info) return label;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      {label}
      <Tooltip
        label={info}
        withArrow
        multiline
        w={260}
        position="top"
        events={{ hover: true, focus: true, touch: true }}
      >
        <IconInfoCircle
          size={15}
          stroke={1.8}
          style={{
            color: 'var(--mantine-color-gray-6)',
            cursor: 'help',
            display: 'inline-block',
            verticalAlign: 'middle',
          }}
        />
      </Tooltip>
    </span>
  );
}

export default LabelWithInfo;
